export default {
  // Header
  'header.total': 'Total',
  'header.balanceSummary': 'Balance Summary',
  'header.showValues': 'Show values',
  'header.hideValues': 'Hide values',
  'header.digitalAccount': 'Digital Account',
  'header.availableBalance': 'Available balance',
  'header.viewStatement': 'View statement',
  'header.incentivePoints': 'Incentive Points',
  'header.totalAccumulated': 'Total accumulated',
  'header.totalEquity': 'Total Equity',
  'header.accountPlusPoints': 'Account + Converted points',
  'header.notifications': 'Notifications',
  'header.markAllAsRead': 'Mark all as read',
  'header.noNotifications': 'No notifications',
  'header.viewAllNotifications': 'View all notifications',
  'header.deleteNotification': 'Delete notification',
  'header.myProfile': 'My Profile',
  'header.companyData': 'Company Data',
  'header.settings': 'Settings',
  'header.logout': 'Logout',
  'header.switchCompany': 'Switch company',
  'header.selectCompany': 'Select company:',

  // Sidebar
  'sidebar.home': 'Home',
  'sidebar.incentive': 'Incentive',
  'sidebar.dashboard': 'Dashboard',
  'sidebar.campaigns': 'Campaigns',
  'sidebar.participants': 'Participants',
  'sidebar.participantsList': 'Participants List',
  'sidebar.registrations': 'Registrations',
  'sidebar.sendInvites': 'Send Invites',
  'sidebar.performance': 'Performance',
  'sidebar.points': 'Points',
  'sidebar.scoring': 'Scoring',
  'sidebar.buyPoints': 'Buy Points',
  'sidebar.distribution': 'Distribution',
  'sidebar.deposit': 'Deposit',
  'sidebar.pointsStatement': 'Points Statement',
  'sidebar.digitalAccountStatement': 'Digital Account Statement',
  'sidebar.rewards': 'Rewards',
  'sidebar.simulator': 'Simulator',
  'sidebar.gamification': 'Gamification',
  'sidebar.levels': 'Levels & Progression',
  'sidebar.badges': 'Badges',
  'sidebar.missions': 'Missions & Challenges',
  'sidebar.games': 'Games & Raffles',
  'sidebar.xpRules': 'XP Rules',
  'sidebar.logs': 'Logs & History',
  'sidebar.analytics': 'Analytics',
  'sidebar.support': 'Support',

  // Common buttons
  'button.new': 'New',
  'button.edit': 'Edit',
  'button.delete': 'Delete',
  'button.save': 'Save',
  'button.cancel': 'Cancel',
  'button.confirm': 'Confirm',
  'button.close': 'Close',
  'button.search': 'Search',
  'button.filter': 'Filter',
  'button.export': 'Export',
  'button.import': 'Import',
  'button.view': 'View',
  'button.download': 'Download',
  'button.upload': 'Upload',
  'button.add': 'Add',
  'button.remove': 'Remove',
  'button.back': 'Back',
  'button.next': 'Next',
  'button.previous': 'Previous',
  'button.finish': 'Finish',
  'button.approve': 'Approve',
  'button.reject': 'Reject',
  'button.send': 'Send',

  // Common labels
  'label.name': 'Name',
  'label.email': 'Email',
  'label.phone': 'Phone',
  'label.cpf': 'CPF',
  'label.cnpj': 'CNPJ',
  'label.date': 'Date',
  'label.startDate': 'Start Date',
  'label.endDate': 'End Date',
  'label.status': 'Status',
  'label.type': 'Type',
  'label.description': 'Description',
  'label.value': 'Value',
  'label.quantity': 'Quantity',
  'label.total': 'Total',
  'label.actions': 'Actions',
  'label.search': 'Search',
  'label.filter': 'Filter',
  'label.all': 'All',
  'label.active': 'Active',
  'label.inactive': 'Inactive',
  'label.pending': 'Pending',
  'label.approved': 'Approved',
  'label.rejected': 'Rejected',
  'label.completed': 'Completed',
  'label.inProgress': 'In Progress',
  'label.scheduled': 'Scheduled',
  'label.cancelled': 'Cancelled',

  // Notifications
  'notification.newCampaign': 'New campaign available',
  'notification.pointsCredited': 'Points credited to your account',
  'notification.goalAchieved': 'Monthly goal achieved!',
  'notification.newParticipant': 'New participant added',
  'notification.rewardAvailable': 'Reward available for redemption',

  // Time
  'time.minutesAgo': 'min ago',
  'time.hoursAgo': 'hour ago',
  'time.hoursAgoPlural': 'hours ago',
  'time.daysAgo': 'day ago',
  'time.daysAgoPlural': 'days ago',

  // Messages
  'message.success': 'Operation completed successfully!',
  'message.error': 'An error occurred. Please try again.',
  'message.confirmDelete': 'Are you sure you want to delete?',
  'message.noData': 'No data found',
  'message.loading': 'Loading...',
  'message.saving': 'Saving...',

  // Participants
  'participants.title': 'Participants',
  'participants.list': 'Participants List',
  'participants.registrations': 'Registrations',
  'participants.sendInvites': 'Send Invites',
  'participants.performance': 'Performance',
  'participants.totalParticipants': 'Total Participants',
  'participants.activeParticipants': 'Active Participants',
  'participants.newThisMonth': 'New This Month',
  'participants.averagePoints': 'Average Points',
  'participants.searchPlaceholder': 'Search by name, email or CPF...',
  'participants.filterByStatus': 'Filter by Status',
  'participants.filterByLevel': 'Filter by Level',
  'participants.exportList': 'Export List',
  'participants.importParticipants': 'Import Participants',
  'participants.newParticipant': 'New Participant',
  'participants.viewProfile': 'View Profile',
  'participants.viewHistory': 'View History',
  'participants.editParticipant': 'Edit Participant',
  'participants.deleteParticipant': 'Delete Participant',
  'participants.points': 'Points',
  'participants.level': 'Level',
  'participants.registrationDate': 'Registration Date',
  'participants.lastAccess': 'Last Access',

  // Dashboard
  'dashboard.title': 'Incentive Dashboard',
  'dashboard.subtitle': 'Track the performance of your incentive campaigns',
  'dashboard.activeCampaigns': 'Active Campaigns',
  'dashboard.activeParticipants': 'Active Participants',
  'dashboard.distributedPoints': 'Distributed Points',
  'dashboard.redeemedRewards': 'Redeemed Rewards',
  'dashboard.vsPreviousPeriod': 'vs previous period',
  'dashboard.featuredCampaigns': 'Featured Campaigns',
  'dashboard.viewAll': 'View all',
  'dashboard.participantsRanking': 'Participants Ranking',
  'dashboard.viewFullRanking': 'View full ranking',
  'dashboard.campaignPerformance': 'Campaign Performance',
  'dashboard.points': 'Points',
  'dashboard.participation': 'Participation',
  'dashboard.redemptions': 'Redemptions',
  'dashboard.chartPlaceholder': 'Performance chart will be displayed here',
  'dashboard.chartSubtitle': 'Real-time data from active campaigns',
  'dashboard.quickActions': 'Quick Actions',
  'dashboard.createCampaign': 'Create Campaign',
  'dashboard.newIncentiveCampaign': 'New incentive campaign',
  'dashboard.distributePoints': 'Distribute Points',
  'dashboard.sendPointsToParticipants': 'Send points to participants',
  'dashboard.generateReport': 'Generate Report',
  'dashboard.performanceReport': 'Performance report',
  'dashboard.newCampaign': 'New Campaign',
  'dashboard.thisWeek': 'This Week',
  'dashboard.thisMonth': 'This Month',
  'dashboard.thisQuarter': 'This Quarter',
  'dashboard.thisYear': 'This Year',
  'dashboard.active': 'Active',
  'dashboard.paused': 'Paused',
  'dashboard.participants': 'participants',

  // Participants - List
  participants: {
    title: 'Participants',
    subtitle: 'Manage incentive program participants',
    tabs: {
      list: 'Participant List',
      registrations: 'Registrations',
      invites: 'Send Invites',
      performance: 'Performance'
    },
    filters: {
      search: 'Search by name, email or ID...',
      status: 'Status',
      all: 'All',
      active: 'Active',
      inactive: 'Inactive',
      pending: 'Pending',
      segment: 'Segment',
      allSegments: 'All Segments',
      campaign: 'Campaign',
      allCampaigns: 'All Campaigns'
    },
    table: {
      participant: 'Participant',
      email: 'Email',
      segment: 'Segment',
      points: 'Points',
      level: 'Level',
      status: 'Status',
      registrationDate: 'Registration Date',
      actions: 'Actions'
    },
    actions: {
      viewProfile: 'View Profile',
      editData: 'Edit Data',
      managePoints: 'Manage Points',
      viewHistory: 'View History',
      deactivate: 'Deactivate',
      activate: 'Activate',
      sendMessage: 'Send Message'
    },
    stats: {
      total: 'Total Participants',
      active: 'Active',
      newThisMonth: 'New This Month',
      averagePoints: 'Average Points'
    },
    buttons: {
      newParticipant: 'New Participant',
      importCSV: 'Import CSV',
      exportData: 'Export Data',
      bulkActions: 'Bulk Actions'
    }
  },

  // Participants - Registrations
  registrations: {
    title: 'Participant Registrations',
    subtitle: 'Manage registration requests and approvals',
    filters: {
      search: 'Search by name or email...',
      status: 'Status',
      all: 'All',
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      period: 'Period',
      last7days: 'Last 7 days',
      last30days: 'Last 30 days',
      last90days: 'Last 90 days'
    },
    table: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      segment: 'Segment',
      requestDate: 'Request Date',
      status: 'Status',
      actions: 'Actions'
    },
    actions: {
      viewDetails: 'View Details',
      approve: 'Approve',
      reject: 'Reject',
      requestAdjustment: 'Request Adjustment'
    },
    stats: {
      pending: 'Pending',
      approved: 'Approved Today',
      rejected: 'Rejected',
      approvalRate: 'Approval Rate'
    }
  },

  // Participants - Send Invites
  invites: {
    title: 'Send Invites',
    subtitle: 'Invite new participants to the program',
    form: {
      inviteType: 'Invite Type',
      individual: 'Individual',
      bulk: 'Bulk',
      name: 'Full Name',
      email: 'Email',
      phone: 'Phone (optional)',
      segment: 'Segment',
      selectSegment: 'Select segment',
      campaign: 'Campaign (optional)',
      selectCampaign: 'Select campaign',
      message: 'Custom Message (optional)',
      messagePlaceholder: 'Type a welcome message...',
      csvFile: 'CSV File',
      uploadCSV: 'Upload CSV',
      downloadTemplate: 'Download CSV Template'
    },
    buttons: {
      sendInvite: 'Send Invite',
      sendInvites: 'Send Invites',
      addAnother: 'Add Another',
      clear: 'Clear'
    },
    stats: {
      sent: 'Invites Sent',
      accepted: 'Accepted',
      pending: 'Pending',
      acceptanceRate: 'Acceptance Rate'
    },
    recentInvites: {
      title: 'Recent Invites',
      email: 'Email',
      sentDate: 'Sent Date',
      status: 'Status',
      actions: 'Actions',
      resend: 'Resend',
      cancel: 'Cancel'
    }
  },

  // Participants - Performance
  performance: {
    title: 'Participant Performance',
    subtitle: 'Detailed performance and engagement analysis',
    filters: {
      period: 'Period',
      last7days: 'Last 7 days',
      last30days: 'Last 30 days',
      last90days: 'Last 90 days',
      thisYear: 'This Year',
      segment: 'Segment',
      allSegments: 'All Segments',
      campaign: 'Campaign',
      allCampaigns: 'All Campaigns'
    },
    topPerformers: {
      title: 'Top Performers',
      position: 'Position',
      participant: 'Participant',
      points: 'Points',
      missions: 'Missions',
      rewards: 'Redemptions'
    },
    metrics: {
      totalPoints: 'Total Points Distributed',
      averagePoints: 'Average Points per Participant',
      completedMissions: 'Completed Missions',
      redemptionRate: 'Redemption Rate'
    },
    engagement: {
      title: 'Engagement',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly'
    }
  },

  // Gamification - Levels
  levels: {
    title: 'Levels & Progression',
    subtitle: 'Configure participant progression levels',
    buttons: {
      newLevel: 'New Level',
      reorder: 'Reorder Levels'
    },
    table: {
      level: 'Level',
      name: 'Name',
      xpRequired: 'XP Required',
      benefits: 'Benefits',
      participants: 'Participants',
      actions: 'Actions'
    },
    stats: {
      totalLevels: 'Total Levels',
      averageXP: 'Average XP per Level',
      maxLevel: 'Max Level Reached'
    }
  },

  // Gamification - Badges
  badges: {
    title: 'Badges & Achievements',
    subtitle: 'Manage system badges and achievements',
    buttons: {
      newBadge: 'New Badge',
      categories: 'Categories'
    },
    filters: {
      search: 'Search badges...',
      category: 'Category',
      allCategories: 'All Categories',
      rarity: 'Rarity',
      allRarities: 'All Rarities'
    },
    table: {
      badge: 'Badge',
      description: 'Description',
      category: 'Category',
      rarity: 'Rarity',
      criteria: 'Criteria',
      earned: 'Earned',
      actions: 'Actions'
    }
  },

  // Gamification - XP Rules
  xpRules: {
    title: 'XP Rules',
    subtitle: 'Configure how participants earn experience',
    buttons: {
      newRule: 'New Rule',
      categories: 'Action Categories'
    },
    table: {
      action: 'Action',
      category: 'Category',
      xpAmount: 'XP Amount',
      limit: 'Limit',
      status: 'Status',
      actions: 'Actions'
    },
    stats: {
      totalRules: 'Total Rules',
      averageXP: 'Average XP per Action',
      mostUsed: 'Most Used Rule'
    }
  },

  // Gamification - Logs
  logs: {
    title: 'Activity Logs',
    subtitle: 'Complete history of system actions and events',
    filters: {
      search: 'Search in logs...',
      type: 'Event Type',
      allTypes: 'All Types',
      period: 'Period',
      last24h: 'Last 24h',
      last7days: 'Last 7 days',
      last30days: 'Last 30 days',
      user: 'User',
      allUsers: 'All Users'
    },
    table: {
      timestamp: 'Date/Time',
      user: 'User',
      action: 'Action',
      details: 'Details',
      ip: 'IP',
      status: 'Status'
    }
  },

  // Gamification - Analytics
  analytics: {
    title: 'Analytics & Reports',
    subtitle: 'Detailed analysis of gamification data and metrics',
    tabs: {
      overview: 'Overview',
      engagement: 'Engagement',
      progression: 'Progression',
      rewards: 'Rewards'
    },
    metrics: {
      totalXP: 'Total XP Distributed',
      activeUsers: 'Active Users',
      completionRate: 'Completion Rate',
      averageLevel: 'Average Level'
    }
  },

  // Incentive - Campaigns
  campaigns: {
    title: 'Campaigns',
    subtitle: 'Manage your incentive campaigns',
    buttons: {
      newCampaign: 'New Campaign',
      templates: 'Templates'
    },
    filters: {
      search: 'Search campaigns...',
      status: 'Status',
      all: 'All',
      active: 'Active',
      scheduled: 'Scheduled',
      completed: 'Completed',
      paused: 'Paused'
    },
    table: {
      campaign: 'Campaign',
      period: 'Period',
      participants: 'Participants',
      budget: 'Budget',
      distributed: 'Distributed',
      status: 'Status',
      actions: 'Actions'
    },
    stats: {
      active: 'Active Campaigns',
      totalBudget: 'Total Budget',
      distributed: 'Distributed',
      participants: 'Participants'
    }
  },

  // Incentive - Scoring
  scoring: {
    title: 'Scoring',
    subtitle: 'Manage rules and point distribution',
    buttons: {
      newRule: 'New Rule',
      distribute: 'Distribute Points'
    }
  },

  // Incentive - Rewards
  rewards: {
    title: 'Rewards',
    subtitle: 'Prize catalog and redemptions',
    buttons: {
      newReward: 'New Reward',
      categories: 'Categories'
    },
    filters: {
      search: 'Search rewards...',
      category: 'Category',
      allCategories: 'All Categories',
      availability: 'Availability',
      all: 'All',
      available: 'Available',
      outOfStock: 'Out of Stock'
    }
  },

  // Incentive - Points Statement
  pointsStatement: {
    title: 'Points Statement',
    subtitle: 'History of point transactions',
    filters: {
      search: 'Search by participant...',
      period: 'Period',
      type: 'Transaction Type',
      allTypes: 'All Types'
    }
  },

  // Incentive - Simulator
  simulator: {
    title: 'Campaign Simulator',
    subtitle: 'Simulate campaign results and costs',
    form: {
      campaignName: 'Campaign Name',
      participants: 'Number of Participants',
      duration: 'Duration (days)',
      pointsPerAction: 'Points per Action',
      estimatedActions: 'Estimated Actions per Participant'
    },
    results: {
      title: 'Simulation Results',
      totalPoints: 'Total Points',
      estimatedCost: 'Estimated Cost',
      roi: 'Estimated ROI'
    }
  },

  // Common
  common: {
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    view: 'View',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    import: 'Import',
    loading: 'Loading...',
    noData: 'No data found',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    close: 'Close',
    actions: 'Actions',
    status: 'Status',
    date: 'Date',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    description: 'Description',
    menu: {
      home: 'Home',
      campaigns: 'Campaigns',
      missions: 'Missions',
      levels: 'Levels',
      badges: 'Badges',
      games: 'Games',
      training: 'Training',
      social: 'Social',
      rewards: 'Rewards',
      statement: 'Statement',
      support: 'Support',
    }
  }
};